import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import t from "../core/Plugin";

var e = /*#__PURE__*/function (_t) {
  _inherits(e, _t);

  var _super = _createSuper(e);

  function e(t) {
    var _this;

    _classCallCheck(this, e);

    _this = _super.call(this, t);
    _this.opts = Object.assign({}, {
      excluded: e.defaultIgnore
    }, t);
    _this.ignoreValidationFilter = _this.ignoreValidation.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(e, [{
    key: "install",
    value: function install() {
      this.core.registerFilter("element-ignored", this.ignoreValidationFilter);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.core.deregisterFilter("element-ignored", this.ignoreValidationFilter);
    }
  }, {
    key: "ignoreValidation",
    value: function ignoreValidation(t, _e2, i) {
      return this.opts.excluded.apply(this, [t, _e2, i]);
    }
  }], [{
    key: "defaultIgnore",
    value: function defaultIgnore(t, _e, i) {
      var r = !!(_e.offsetWidth || _e.offsetHeight || _e.getClientRects().length);

      var n = _e.getAttribute("disabled");

      return n === "" || n === "disabled" || _e.getAttribute("type") === "hidden" || !r;
    }
  }]);

  return e;
}(t);

export { e as default };